var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cited-push-templateConfigDetail"},[_c('templateConfigDetail',{attrs:{"template-options":_vm.subscribeTypes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }